module.exports = __webpack_public_path__ + "img/16l002-07.2e26b1aa.png";